// Funcs
const randomString = (length) => {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

// Vars/consts
const AUTH_TOKEN_KEY = 'userAuthToken'
const AUTH_USER_SHOP = 'userShop'

module.exports = {
    randomString,
    AUTH_TOKEN_KEY,
    AUTH_USER_SHOP
};